import { fonts, grid } from "../../tokens";
import { facepaintMediaQueries } from "../shared";
export var circle = {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  flex: "1 0 auto",
  width: "24px",
  borderRadius: "50%",
  borderStyle: "solid",
  borderWidth: "2px",
  height: "24px",
  marginRight: "8px"
};
export var number = {
  fontFamily: fonts.family,
  fontSize: "12px",
  fontWeight: fonts.weights.bold
};
export var item = {
  alignItems: "center",
  height: 24,
  display: "inline-flex",
  flexDirection: "row",
  marginRight: grid.xlarge,
  "&:last-of-type": {
    marginRight: "0"
  }
};
export var awaitingItem = facepaintMediaQueries({
  display: ["none", "none", "inline-flex"]
});